import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "../tables/LatestJobs.css";

const AllJobs = () => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
    fetch(`${API_URL}/jobs`)
      .then((res) => res.json())
      .then((data) => setJobs(data.reverse()))
      .catch((err) => console.error(err));
  }, []);

  const getLastDate = (dates = []) => {
    if (!Array.isArray(dates) || dates.length === 0) return null;

    // Find label with "Last Date" or fallback to the latest one
    const lastDateObj =
      dates.find((d) => d.label.toLowerCase().includes("last")) ||
      dates[dates.length - 1];

    if (!lastDateObj?.value) return null;

    const date = new Date(lastDateObj.value);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }); // Format: 14 July 2025
  };

  return (
    <div className="table-card all-jobs-table" style={{ maxWidth: "900px", margin: "2rem auto" }}>
      <h3 className="table-title">All Jobs</h3>
      <table className="styled-table">
        <thead>
            <tr>
              <th>Job</th>
              <th className="desktop-only">Last Date</th>
            </tr>
          </thead>
          <tbody>
            {jobs.map((job, index) => (
              <tr key={index}>
                <td>
                  <span style={{ color: "#000", fontWeight: "bold",fontSize: "20px", lineHeight: "1", marginRight: "8px",}}>•</span>
                  {/* <span style={{ color: "black", marginRight: "8px" }}>•</span> */}
                  <Link to={`/job/${job.slug}`} className="job-link">
                    {job.JobTitle}
                  </Link>
                  {/* 👇 This will show only on mobile */}
                  <span className="mobile-only job-date-inline">
                    {" - " + (getLastDate(job.dates) || "-")}
                  </span>
                </td>

                <td className="desktop-only" style={{ color: "red", fontWeight: "normal" }}>
                  {getLastDate(job.dates) || "-"}
                </td>
              </tr>
            ))}
          </tbody>

      </table>
    </div>
  );
};

export default AllJobs;
